import { Api } from '../api';
import { IResponseLogChaveValor } from 'shared/types/chaveValor';

const getAll = async (filter = ''): Promise<IResponseLogChaveValor | Error> => {
  try{
    const { data, status } = await Api.get(`/Orgs/ChaveValorLog/chaveValorLog${filter !== '' ? '?' : ''}${filter}`);
    if (data) {
      return data.retornoPagina;
    }

    if (status === 204) {
      return {rows:[],count: 0};
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};



export const LogChaveValorService = {
  getAll,
  
};
